import React, { FC } from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

const MarkdownRenderer: FC<{ markdown: string }> = ({ markdown }) => {
	return (
		<ReactMarkdown
			className='react-markdown line-break'
			components={{
				a: ({ node, ...props }) => (
					<a {...props} target='_blank' rel='noopener noreferrer' style={{ color: '#023671' }}>
						{props.children}
					</a>
				),
				ol: ({ node, ...props }) => {
					const listStyleType = 'revert-layer';
					return <ol {...props} style={{ listStyleType }} />;
				},
			}}
			rehypePlugins={[rehypeRaw]} // Erlaubt das Parsen von HTML-Tags wie <u>
			skipHtml={false}
		>
			{markdown}
		</ReactMarkdown>
	);
};

export default MarkdownRenderer;
